import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const OrderDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [order, setOrder] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchDetails();
    }, [id]);

    const fetchDetails = async () => {
        try {
            const formData = new FormData();
            formData.append('order_id', id);

            const response = await axios.post('https://rotica.in/get_order_details.php', formData);
            if (response.data.success) {
                setOrder(response.data.order);
                setItems(response.data.items);
            } else {
                setError(response.data.message);
            }
        } catch (err) {
            setError("Failed to fetch details.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="loading-screen">Loading Details...</div>;
    if (error) return <div className="error-text">{error}</div>;
    if (!order) return <div className="error-text">Order not found</div>;

    return (
        <div className="dashboard-container"> {/* Reuse container */}
            <div className="details-header">
                <button className="back-btn" onClick={() => navigate('/dashboard')}>← Back</button>
                <h1>Order #{order.id}</h1>
            </div>

            <div className="order-summary-card">
                <div className="summary-row">
                    <div>
                        <h3>Customer</h3>
                        <p>{order.customer_name}</p>
                        <p className="sub-text">{order.contact_no}</p>
                    </div>
                    <div>
                        <h3>Status</h3>
                        <span className={`status-badge ${order.status?.toLowerCase().replace(/\s/g, '-')}`}>
                            {order.status}
                        </span>
                    </div>
                    <div>
                        <h3>Subscription Period</h3>
                        <p>{order.start_date} to {order.end_date}</p>
                    </div>
                </div>

                <div className="address-section">
                    <h3>Delivery Address</h3>
                    <p>{order.address_text}</p>
                    <p><strong>Time:</strong> {order.delivery_time}</p>
                    {order.remarks && <p><strong>Remarks:</strong> {order.remarks}</p>}
                </div>
            </div>

            <div className="items-section">
                <h2>Message/Items</h2>
                <div className="table-wrapper">
                    <table className="orders-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Specs</th>
                                <th>Qty</th>
                                <th>Pack Of</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item.base_name || `Product #${item.product_id}`}</td>
                                    <td>{item.weight_spec} / {item.size_spec}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.pack_size || 1}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
